import "animate.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/lib/amplify";

import "./app/global.css";
import App from "./app/pages";
import "./lib/sentry";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
